<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card class="card-plain">
          <!-- <template slot="header">
            <h4 class="card-title">Table on Plain Background</h4>
            <p class="category">Here is a subtitle for this table</p>
          </template>-->
          <div class="table-full-width text-left">
            <deploymentServer-table
            v-if="deploymentServers && deploymentServers.length > 0"
				:title="table1.title"
				:sub-title="table1.subTitle"
				:deploymentServers="deploymentServers"
				:totalElements="totalElements"
				:page="page"
				:columns="table1.columns"
 				@get-all-deployment-servers="getAllDeploymentServers"
             >

            </deploymentServer-table>
          </div>
        </card>
      </div>

    </div>
  </div>
</template>
<script>
import { Card } from "@/components/Card";

import DeploymentServerTable from "@/components/DeploymentServerTable";
import DeploymentServerService from "../services/DeploymentServerService";

const tableColumns = [];
const tableData = [
];

export default {
  components: {
    Card,
    DeploymentServerTable,
  },
  data() {
    return {
      deploymentServers: [],
	  totalElements: 0,
      page: 0,
      searchQuery: '',     
      table1: {
        title: "Simple Table",
        columns: [...tableColumns],
        data: [...tableData],
      },
    };
  },
  methods: {
    async getAllDeploymentServers(sortBy='deploymentServerId',sortOrder='true',page="0",size="50") {
      try {
        try {
			const searchDTO = {
				sortBy: sortBy, 
				sortOrder: sortOrder, 
				searchQuery: this.searchQuery,
				page: page, 
				size: size
			};
	        let response = await DeploymentServerService.getAllDeploymentServers(searchDTO);
	        if (!response.data.empty) {
		        if (response.data.deploymentServers.length) {
					this.deploymentServers = response.data.deploymentServers;
				}
      			this.totalElements = response.data.totalElements;
      			this.page = response.data.page;
	        }
        } catch (error) {
          console.error("Error fetching deploymentServers:", error);
        }
        
      } catch (error) {
        console.error("Error fetching deploymentServer details:", error);
      }
    },
  },
  mounted() {
    this.getAllDeploymentServers();
  },
  created() {
    this.$root.$on('searchQueryForDeploymentServersChanged', (searchQuery) => {
    	this.searchQuery = searchQuery;
    	this.getAllDeploymentServers();
    }),
    this.$root.$on('selectedPageSizeChanged', (selectedPageSizeChanged) => {
    	this.pageSize = selectedPageSizeChanged;
    	this.page = 0;
    	this.getAllDeploymentServers('deploymentServerId', 'desc', this.page, this.pageSize);
    })
  }
};
</script>
<style></style>
